import {Button, Modal, Table,Checkbox, Row} from 'antd'
import React, {useEffect, useRef, useState} from 'react'
import {Scrollbar} from "smooth-scrollbar-react";
import {Scrollbar as BaseScrollbar} from "smooth-scrollbar/scrollbar";
import './classificationModal.scss'
import {AddIcon, ModalCloseIco, RemoveIconAvans} from "../../../../../../modules/CustomIcons";
import {useTranslation} from "react-i18next";

const ClassificationModal : React.FC<any> = (props) => {
    const {t}= useTranslation()
    // console.log("rr",props?.data);
    
    const [listData,setListData] = useState(props.data.data || [])
    const [newlistData,setNewlistData] = useState([])
    const [addIcon,setAddIcon] = useState(true)
    const [key,setKey] = useState()
    const [subTable,setSubTable] = useState([])
    const [checked,setChecked] = useState([])
    const [budgetCodeCheck,setBudgetCodeCheck]=useState([])
    const onClose = () => {
        props.onClose((old_value) => false)
    }

    useEffect(() => {
        setListData(props.data.data)
        setNewlistData(listData?.unUsedPrePaidServiceGroupList?.map(item => ({ ...item, expanded: false })))


    }, [props.data])

    const addOrRemove = (index: number) => {
    setNewlistData(prev =>
        prev.map((item, i) =>
        i === index ? { ...item, expanded: !item.expanded } : item
        )
    );
    };




    const customFooter =() =>(
      <>
          <div className={"flex justify_between align_center"}>
          <Button onClick={onClose} type={'button'} className={'light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center'}>
              {t('common.cancel')}
          </Button>
          <Button type={"button"}
                    onClick={()=>props.selectedList(checked)}
                  className={'blue-button next_btn btn flex align_center justify_center'}>
              {t("transfers.addClass")}
          </Button>
      </div>
      </>


    )
    const checkBoxChange=(e,code,budgetCode)=>{
        e.stopPropagation()

        var updatedList = [...checked];
        var budgetlist = [...budgetCodeCheck]

        if (e.target.checked) {
            budgetlist = [...budgetCodeCheck,budgetCode]
            updatedList = [...checked, code];

        } else {
            updatedList.splice(checked.indexOf(code), 1);
            budgetlist.splice(checked.indexOf(budgetCode),1)
        }

        setChecked(updatedList);
    }

    // const checkBoxChange=(e,code)=>{
    //     e.stopPropagation()
    //
    //     var updatedList:any = [];
    //
    //
    //     if (e.target.checked) {
    //
    //         updatedList = [code];
    //
    //     } else {
    //         updatedList.splice(checked.indexOf(code), 1);
    //
    //     }
    //
    //     setChecked(updatedList);
    // }

    return (
        <>
            <Modal
                open={props.visible}
                title={t('transfers.choosePayService')}
                footer={customFooter()}
                onCancel={onClose}
                centered
                className={'classificationModal'}
                closeIcon={<ModalCloseIco />}
                width={760}
            >
                <>
                    <div  className={'classificationModal_header'}>
                        <div style={{fontSize:16,marginBottom:40}}>
                        <p>{props.transferType}</p>
                        <>{listData?.serviceAccount?.abonCode} : {listData?.serviceAccount?.description}</>
                    </div>
                        <p  style={{fontSize:24}}>{t("transfers.Advancepayment")} </p>
                    </div>

                <Scrollbar
                    plugins={{
                        overscroll: {
                            effect: 'glow',
                        },
                    }}
                >
                    <div style={{display: 'flex',maxHeight:400,marginLeft:25}}>


                            <ul>
                                {
                                    newlistData?.map((row:any,index:number)=>{
                                        return(
                                            <>
                                                <li  key={index}  style={{width:710,cursor:"pointer"}}>
                                                <div  className={'flex align_center avansList'} onClick={()=>addOrRemove(index, row)}>
                                                        {
                                                            row.expanded ? <div className={'flex align_center '}>
                                                                    <div className={'icon'}><RemoveIconAvans /></div>
                                                                    <p style={{marginLeft:10}}> {row.description}</p>
                                                            </div>
                                                                : <div className={'flex align_center '}>
                                                                   <div className={'icon'} > <AddIcon/> </div>
                                                                       <p style={{marginLeft:10}}> {row.description}</p>
                                                                </div>

                                                            // addIcon ? <div className={'flex'} onClick={()=>addOrRemove(index,row, "add")}><AddIcon />    <p style={{marginLeft:10}}>   {row.description}</p></div> :( row.code === key ?
                                                            //     <div className={'flex'} onClick={()=>addOrRemove(index,row, "remove")}><RemoveIconAvans />    <p style={{marginLeft:10}}>   {row.description}</p></div>
                                                            //     : <div className={'flex'} onClick={()=>addOrRemove(index,row, "add")}><AddIcon />    <p style={{marginLeft:10}}>   {row.description}</p></div>)
                                                            //
                                                        }
                                                </div>

                                                    {
                                                        row.expanded &&
                                                        row.prePaidServiceList?.map((item)=>{
                                                            return(
                                                                <Row className={''} >
                                                                    <Checkbox
                                                                        // style={{marginRight:10}}
                                                                        name={'checkBox'}
                                                                        style={{margin:'16px 27px 30px 45px'}}
                                                                        checked={checked?.includes(item.code.toString())}
                                                                        onClick={(e) => checkBoxChange(e, item.code.toString(),item.budgetCode.toString())}
                                                                    >
                                                                        <div style={{width:635}}>{item.budgetCode} - {item.description}</div>
                                                                    </Checkbox>

                                                                </Row>
                                                            )
                                                        })

                                                    }
                                            </li>

                                            </>

                                        )
                                    })
                                }
                            </ul>


                    </div>
                </Scrollbar>
                </>
            </Modal>
        </>
    )
}
export default ClassificationModal